import React from "react";

const NotFound = () => {
  return (
    <main className="main-error">
      <section className="error">
        <img src="/img/notFound.png" alt="404" />
        <h2>صفحه مورد نظر یافت نشد</h2>
      </section>
    </main>
  );
};

export default NotFound;
